module.exports = __webpack_public_path__ + "static/linkedin-c164f5296af2247d6cbd20f30974adde.png";